import { SelectContact } from 'components/Contacts/selectContact';
import { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import mechanicalServices from './mechanicalServices';

export default function CollectorSelection(param: any) {

    let [saveSuccess, setsaveSuccess] = useState(false);
    let [openContact, SetOpenContact] = useState(false);
    let [saveAllSuccess, setsaveAllSuccess] = useState(false);
    let [mechanicalSelect, SetMechanicalSelect] = useState<any>([]); 

    useEffect(() => {
        if (param?.EditCollectorData) {
            SetMechanicalSelect({ ...param.EditCollectorData });

        }
    }, [param?.EditCollectorData]);

    const onChangeCollectorSelection = () => { param.onChangeCollectorSelection() }

    const onChangeContact = (e: any) => {
        console.log(param?.EditCollectorData)
        console.log(e)
        openContact = false;
        SetOpenContact(openContact);

        mechanicalSelect.collectedTo = e?.data?.kontactCode;
        mechanicalSelect.collectorName = e?.data?.kontactDisplay;

        SetMechanicalSelect(mechanicalSelect)
    }

    const updateCollectorName = () => {
        var payload = { accountTo: mechanicalSelect.collectedTo, mechRefField: null, oldCollectedTo: param?.EditCollectorData?.collectedTo }
        console.log(payload)
        mechanicalServices.collectorNameSave(payload).then((respond: any) => {

            if (respond) {
                setsaveSuccess(true)
            }

            setTimeout(function () {
                setsaveSuccess(false);
            }, 3000);
        })
    }

    const updateAllCollectorName = () => {
        var payload = { accountTo: mechanicalSelect.collectedTo, oldCollectedTo: param?.EditCollectorData?.collectedTo }
        mechanicalServices.collectorNameSaveAll(payload).then((respond: any) => {
            if (respond) {
                setsaveAllSuccess(true)
            }

            setTimeout(function () {
                setsaveAllSuccess(false);
            }, 3000);
        })
    }
 
    return (<>

        <Drawer open={param.openCollectorSelection} onClose={onChangeCollectorSelection} direction='right' className='react-drawer allowHscroll' size={800}>

            <div className="box ws-6 pull-right">

                <div className="ws-12"> <div className="box-header noBorderRadius bg-blue text-bold"><h2>Edit Collector Name</h2></div> </div>

                <div className="box-content">

                    {saveSuccess && <div className="alert alert-success "> New collector name saved successfully</div>}
                    {saveAllSuccess && <div className="alert alert-success "> All identical collector name having same  publisher have been saved successfully  </div>}

                    <div className="ws-12">
                        <div className="form-format">
                            <label className="control-label ">Collector Name</label>

                            <div className="label-entries">
                                <div className="ws-7">
                                    <input type="text" name="kontactDisplay" placeholder="Enter collector name" value={mechanicalSelect?.collectorName} readOnly required />
                                </div>
                                <div className="ws-5">
                                    <button type="button" className="btn icon-btn edit" onClick={() => SetOpenContact(true)} title="Select Contact"><i className="icon-user-add"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="box-footer pull-right">
                    <button title="Save changes for this Collector Name only" className="icon-btn edit mb width100 height35" onClick={updateCollectorName}> Save </button>
                    <button title="Save changes for all identical Collector Name having same Publisher" className="width100 height35 icon-btn edit mb" onClick={updateAllCollectorName}> Save all </button>
                    <button className="icon-btn delete mb mr width100 height35" onClick={onChangeCollectorSelection}><i className="icon-close"></i>Close  </button>
                </div>
            </div>

        </Drawer>

        {(() => {

            if (openContact) {
                return <SelectContact SelectContactImprint={onChangeContact} data={{ contractArtist: mechanicalSelect?.collectedTo }} hide={true} open={openContact} />
            }

        })()}
    </>)
}